import * as React from "react"
import { SaleAdvert } from "../../../types/types";

type Props = {
  advert: SaleAdvert
}

export default (props: Props) : JSX.Element => (
  props.advert.maintenance ?
    <>
      <div className="content-part">
        <h3>
          {I18n.t('sale_adverts.description.construction_state')}
        </h3>
        <div className="description">
          {I18n.t(`sale_adverts.maintenance_states.${props.advert.maintenance}`)}
        </div>
      </div>
      <hr />
    </>
  : <></>
)
